import { getAssistTypeApi } from '@/api/supplierSku/supplierPurchaseSettlementManage'

const purchaseSettlementManage = {
  state: {
    assistTypeList: [],
  },
  actions: {

    getAssistTypeList({ commit, state }) {
      if (state.assistTypeList.length === 0) {
        getAssistTypeApi({
          tableName: "settlementAssistType",
        }).then(res => {
          commit('setAssistTypeList', res.data);
        }).catch(err => {
          console.log(err)
        })
      }
    },
    resetAssistTypeList({ commit, state }) {
      return new Promise((resolve, reject) => {
        getAssistTypeApi({
          tableName: "settlementAssistType",
        }).then(res => {
          commit('setAssistTypeList', res.data);
          resolve(res);
        }).catch(err => {
          reject(e)
        })

      })

    },
  },
  mutations: {
    setAssistTypeList: (state, data) => {
      state.assistTypeList = data
    },
  }
};

export default purchaseSettlementManage
